var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classify-ring"},[_c('h-title',{attrs:{"text":'产品分类统计'}}),_vm._v(" "),_c('ve-ring',{staticClass:"ring",attrs:{"data":_vm.chartData,"width":"360px","height":"160px","settings":_vm.chartSettings,"extend":_vm.chartExtend}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c02181cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/classifyRing.vue
// module id = null
// module chunks = 